// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import CardContainer, { CardContainerStyles } from "@insite/content-library/Components/CardContainer";
import LazyImage from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import { LazyImageProps } from "@synd/MobiusOverrides/LazyImage";
import React from "react";

type Props = { src: string; alt: string; href: string };

export interface SocialMediaCardStyles {
    cardContainer?: CardContainerStyles;
    image?: LazyImageProps;
}

export const socialMediaCardStyles: SocialMediaCardStyles = {};

const SocialMediaCard: React.FC<Props> = ({ src, alt, href }) => (
    <CardContainer extendedStyles={socialMediaCardStyles.cardContainer}>
        <Link href={href} aria-label={alt}>
            <LazyImage src={src} {...socialMediaCardStyles.image} altText={alt} />
        </Link>
    </CardContainer>
);

export default SocialMediaCard;
